// src/components/update-required-screen.tsx
import React from 'react';
import { useAppUpdate } from '../contexts/app-update-context';
import { UniversalSpinner } from './universal-spinner/universal-spinner';
import { isNative } from '../platform';

export const UpdateRequiredScreen: React.FC = () => {
  const { triggerUpdate, status } = useAppUpdate();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Update required"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483647,
        display: 'grid',
        placeItems: 'center',
        background: '#000000',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      {/* Radial glow (matches AppLoader) */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(800px 500px at 50% 45%, rgba(255,255,255,0.08), transparent 60%)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 20,
          padding: 24,
          maxWidth: 320,
          textAlign: 'center',
        }}
      >
        <img
          src="/logo.svg"
          width={60}
          height={60}
          alt="Mailander logo"
          draggable={false}
          style={{
            display: 'block',
            filter: 'drop-shadow(0 10px 22px rgba(0,0,0,0.45))',
            animation: 'appLoaderPulse 1300ms ease-in-out infinite',
          }}
        />

        <p
          style={{
            color: '#ffffff',
            fontSize: 16,
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 500,
            lineHeight: 1.5,
            margin: 0,
          }}
        >
          A new version of Mailander is available
        </p>

        <p
          style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: 13,
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 400,
            lineHeight: 1.4,
            margin: 0,
          }}
        >
          Please update{isNative() ? ' from your app store' : ''} to get the latest features and fixes.
        </p>

        {status === 'updating' ? (
          <div style={{ display: 'grid', placeItems: 'center', paddingTop: 8 }}>
            <UniversalSpinner />
          </div>
        ) : (
          <button
            onClick={triggerUpdate}
            style={{
              marginTop: 8,
              padding: '12px 32px',
              background: '#5E84ED',
              color: '#ffffff',
              border: 'none',
              borderRadius: 10,
              fontSize: 15,
              fontFamily: 'Inter, system-ui, sans-serif',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'opacity 150ms ease',
            }}
            onMouseEnter={(e) => {
              (e.target as HTMLButtonElement).style.opacity = '0.85';
            }}
            onMouseLeave={(e) => {
              (e.target as HTMLButtonElement).style.opacity = '1';
            }}
          >
            {isNative() ? 'Update in Store' : 'Update'}
          </button>
        )}

        <style>
          {`
            @keyframes appLoaderPulse {
              0%, 100% { transform: translateY(0px) scale(1); opacity: 0.92; }
              50% { transform: translateY(-2px) scale(1.02); opacity: 1; }
            }
          `}
        </style>
      </div>
    </div>
  );
};
